import { useParams } from 'react-router-dom';

import pickMealAtAtom from '~/recoil/atom/pickMealAt';
import { useRecoilValue } from 'recoil';

import useStore from '~/hooks/useStore';
import useStoreMenuList from '~/pages/Store/hooks/useStoreMenuList';

type StoreProviderProps = {
  children: React.ReactElement | null;
};

export default function StoreProvider({ children }: StoreProviderProps) {
  const { storeId } = useParams();
  const pickMealAt = useRecoilValue(pickMealAtAtom);

  useStore(storeId || '');
  useStoreMenuList(storeId || '', pickMealAt);

  return children;
}
